import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { DateService, TextService } from "@src/services";
import { normalize } from "@src/utils";

export const useToday = () => {
  const i18n = useI18n();

  const today = computed(() => {
    const today_list = [
      {
        id: "today_0",
        title: DateService.getDateDaysAgo(0, i18n.locale.value),
        subtitle: i18n.t("Сегодня"),
      },
      {
        id: "today_1",
        title: DateService.getDateDaysAgo(1, i18n.locale.value),
        subtitle: i18n.t("Вчера"),
      },
      {
        id: "today_2",
        title: DateService.getDateDaysAgo(2, i18n.locale.value),
        subtitle: TextService.capitalize(DateService.getWeekdayDaysAgo(2, i18n.locale.value)),
      },
      {
        id: "today_3",
        title: DateService.getDateDaysAgo(3, i18n.locale.value),
        subtitle: TextService.capitalize(DateService.getWeekdayDaysAgo(3, i18n.locale.value)),
      },
      {
        id: "today_4",
        title: DateService.getDateDaysAgo(4, i18n.locale.value),
        subtitle: TextService.capitalize(DateService.getWeekdayDaysAgo(4, i18n.locale.value)),
      },
      {
        id: "today_5",
        title: DateService.getDateDaysAgo(5, i18n.locale.value),
        subtitle: TextService.capitalize(DateService.getWeekdayDaysAgo(5, i18n.locale.value)),
      },
      {
        id: "today_6",
        title: DateService.getDateDaysAgo(6, i18n.locale.value),
        subtitle: TextService.capitalize(DateService.getWeekdayDaysAgo(6, i18n.locale.value)),
      },
      {
        id: "today_7",
        title: DateService.getDateDaysAgo(7, i18n.locale.value),
        subtitle: TextService.capitalize(DateService.getWeekdayDaysAgo(7, i18n.locale.value)),
      },
    ];

    return normalize(today_list, "id");
  });

  return today;
};
